class CustomProductSlider {
  constructor(container) {
    this.container = container;
    this.items = container.querySelectorAll(".product-slider-item");
    this.prevBtn = container.querySelector(".product-slider-prev");
    this.nextBtn = container.querySelector(".product-slider-next");
    this.currentIndex = 0;
    this.isTransitioning = false;
    this.autoplayInterval = null;
    this.autoplayDelay = 5000;

    this.init();
  }

  init() {
    if (this.items.length === 0) return;

    this.bindEvents();
    this.setActiveSlide(0);
    this.startAutoplay();
  }

  bindEvents() {
    this.prevBtn?.addEventListener("click", () => this.prevSlide());
    this.nextBtn?.addEventListener("click", () => this.nextSlide());

    this.bindTouchEvents();

    this.container.addEventListener("mouseenter", () => this.stopAutoplay());
    this.container.addEventListener("mouseleave", () => this.startAutoplay());

    document.addEventListener("keydown", (e) => this.handleKeydown(e));
  }

  bindTouchEvents() {
    let startX = 0;
    let startY = 0;
    let threshold = 50;

    this.container.addEventListener(
      "touchstart",
      (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    this.container.addEventListener(
      "touchmove",
      (e) => {
        if (
          Math.abs(e.touches[0].clientX - startX) >
          Math.abs(e.touches[0].clientY - startY)
        ) {
          e.preventDefault();
        }
      },
      { passive: false }
    );

    this.container.addEventListener(
      "touchend",
      (e) => {
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const diffX = startX - endX;
        const diffY = startY - endY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > threshold) {
          if (diffX > 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        }
      },
      { passive: true }
    );
  }

  handleKeydown(e) {
    if (!this.container.matches(":hover")) return;

    switch (e.key) {
      case "ArrowLeft":
        e.preventDefault();
        this.prevSlide();
        break;
      case "ArrowRight":
        e.preventDefault();
        this.nextSlide();
        break;
    }
  }

  prevSlide() {
    if (this.isTransitioning || this.items.length === 0) return;

    const oldIndex = this.currentIndex;
    this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
    
    this.items[oldIndex].classList.add('sliding-out-right');
    this.items[this.currentIndex].classList.add('sliding-in-left');
    
    setTimeout(() => {
      this.setActiveSlide(this.currentIndex);
      this.items[oldIndex].classList.remove('sliding-out-right');
      this.items[this.currentIndex].classList.remove('sliding-in-left');
    }, 50);
    
    this.resetAutoplay();
  }

  nextSlide() {
    if (this.isTransitioning || this.items.length === 0) return;

    const oldIndex = this.currentIndex;
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    
    this.items[oldIndex].classList.add('sliding-out-left');
    this.items[this.currentIndex].classList.add('sliding-in-right');
    
    setTimeout(() => {
      this.setActiveSlide(this.currentIndex);
      this.items[oldIndex].classList.remove('sliding-out-left');
      this.items[this.currentIndex].classList.remove('sliding-in-right');
    }, 50);
    
    this.resetAutoplay();
  }

  getPrevIndex(index) {
    return (index - 1 + this.items.length) % this.items.length;
  }

  getNextIndex(index) {
    return (index + 1) % this.items.length;
  }

  setActiveSlide(index) {
    if (this.isTransitioning) return;

    this.isTransitioning = true;

    // Remove all classes first
    this.items.forEach((item) => {
      item.classList.remove("active", "prev", "next", "hidden-left", "hidden-right");
    });

    const prevIndex = this.getPrevIndex(index);
    const nextIndex = this.getNextIndex(index);

    // Set positions
    this.items[index].classList.add("active");
    this.items[prevIndex].classList.add("prev");
    this.items[nextIndex].classList.add("next");

    // Hide all other items
    this.items.forEach((item, i) => {
      if (i !== index && i !== prevIndex && i !== nextIndex) {
        item.classList.add("hidden-left");
      }
    });

    this.currentIndex = index;

    setTimeout(() => {
      this.isTransitioning = false;
    }, 600);
  }

  startAutoplay() {
    if (this.items.length <= 1) return;

    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  goToSlide(index) {
    if (index >= 0 && index < this.items.length) {
      this.setActiveSlide(index);
      this.resetAutoplay();
    }
  }

  destroy() {
    this.stopAutoplay();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".custom-product-slider");
  sliders.forEach((slider) => {
    new CustomProductSlider(slider);
  });
});

document.addEventListener("shopify:section:load", function (event) {
  if (event.detail.sectionId) {
    const slider = event.target.querySelector(".custom-product-slider");
    if (slider) {
      new CustomProductSlider(slider);
    }
  }
});

document.addEventListener("shopify:section:select", function (event) {
  const slider = event.target.querySelector(".custom-product-slider");
  if (slider && slider.productSlider) {
    slider.productSlider.stopAutoplay();
  }
});

document.addEventListener("shopify:section:deselect", function (event) {
  const slider = event.target.querySelector(".custom-product-slider");
  if (slider && slider.productSlider) {
    slider.productSlider.startAutoplay();
  }
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = CustomProductSlider;
}